import { render, staticRenderFns } from "./BlogDetails.vue?vue&type=template&id=113a1842&scoped=true&"
import script from "./BlogDetails.vue?vue&type=script&lang=js&"
export * from "./BlogDetails.vue?vue&type=script&lang=js&"
import style0 from "./BlogDetails.vue?vue&type=style&index=0&id=113a1842&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113a1842",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VIcon,VImg,VRow})
